import React from 'react';
import { useSelector } from 'react-redux';
import { RootReducersState } from 'redux/reducers';
import commonService from 'utils/commonService';
import { IProps } from './types';

const MortgageInfo: React.FC<IProps> = (props) => {
  const resources = useSelector((state: RootReducersState) => state.resources);
  return (
    <div className="mortgage-info">
      <div className="mortgage-info__title">{commonService.getNameByLng(resources, 'TID_Mortgage_information')}</div>
      <div className="mortgage-info__content">
        <div className="element__list">
          <div className="element__list-col">
            <div className="element__list-group">
              <div className="element__list-group-title">{commonService.getNameByLng(resources, 'TID_Mortgagee')}</div>
              <div className="element__list-group-content">
                {
                  props.HDR_ID
                    ? `${props.HDR_ID}${props.HBRCH_NAME ?? props.HDR_NAME}`
                    : '-'
                }
              </div>
            </div>
          </div>
          <div className="element__list-col">
            <div className="element__list-group">
              <div className="element__list-group-title">{commonService.getNameByLng(resources, 'TID_Bank_handling_recipient')}</div>
              <div className="element__list-group-content">
                {
                  props.OPERATOR ? props.OPERATOR : '-'
                }
              </div>
            </div>
          </div>
          <div className="element__list-col">
            <div className="element__list-group">
              <div className="element__list-group-title">{commonService.getNameByLng(resources, 'TID_Bank_delivery_address')}</div>
              <div className="element__list-group-content">
                {
                  props.ADDRESS_FULL ? props.ADDRESS_FULL : '-'
                }
              </div>
            </div>
          </div>
          <div className="element__list-col">
            <div className="element__list-group">
              <div className="element__list-group-title">{commonService.getNameByLng(resources, 'TID_Send_policy_to_the_mortgage_bank')}</div>
              <div className="element__list-group-content">
                {
                  props.DELIVER_BANK_TEXT ? props.DELIVER_BANK_TEXT : '-'
                }
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default MortgageInfo;
